import { gql } from "@apollo/client";

export const GET_INDEX_STATS = gql`
  query GetIndexStats($start: ISO8601DateTime!) {
    indexStatsHour: indexStats(start: $start, interval: "hour") {
      averageOffersCount
      averageTripsCount
      bucket
      count
    }
  }
`;
